<template>
  <div class="page-container">
    <!-- header -->
    <el-card>
      <div class="header-bar">
        <div class="header-item">
          <el-switch
            v-model="queryInfo.isNoLock"
            inactive-text="暂未绑锁房间"
            @change="getOrgaApartmentPage">
          </el-switch>
        </div>
        <div class="header-item" v-if="userInfo.userType === 1">
          <el-select clearable v-model="queryInfo.orgaId" placeholder="请选择组织" @clear="clearOrga" @change="getbuildList">
            <el-option
              v-for="item in orgaInfoList"
              :key="item.id"
              :label="item.orgaName"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="header-item">
          <el-select clearable v-model="queryInfo.buildId" placeholder="请选择楼栋" @clear="clearBuild" @change="onBuildChange">
            <el-option
              v-for="item in buildList"
              :key="item.id"
              :label="item.buildName"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="header-item">
          <el-select clearable v-model="queryInfo.floorNum" placeholder="请选择楼层" @clear="getOrgaApartmentPage" @change="getOrgaApartmentPage">
            <el-option
              v-for="item in floorList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="header-item header-search">
          <el-input
            placeholder="请输入关键字搜索"
            class="input-with-select"
            clearable
            v-model="queryInfo.keyword"
            @clear="getOrgaApartmentPage"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getOrgaApartmentPage"
            ></el-button>
          </el-input>
        </div>
        <div class="header-actions">
          <el-button type="success" size="small" @click="batchSenndKey">批量发送锁匙</el-button>
          <el-button type="primary" size="small" @click="createApartment">添加房间</el-button>
          <el-button type="success" size="small" @click="$http.exportExcelHttp.downloadRoomUser()">下载模板</el-button>
          <el-upload
            action=""
            :on-change="importHouse"
            :auto-upload="false"
            :show-file-list="false"
            class="uploadFile"
          >
            <el-button type="warning" size="small">批量导入房间用户</el-button>
          </el-upload>
        </div>
      </div>
    </el-card>
    <!-- body -->
    <el-card>
      <vxe-table
        resizable
        ref="buildTable"
        align="center"
        :max-height="$wHight - 280"
        :data="orgaApartmentList"
        :loading="loading">
        <vxe-column type="checkbox" width="60"></vxe-column>
          <vxe-column type="seq" width="50" title="序号">
          </vxe-column>
         <vxe-column field="roomNum" title="楼层房间号"></vxe-column>
         <vxe-column field="orgaName" title="组织名称"></vxe-column>
         <vxe-column field="featureCode"  width="150" title="锁标识">
          <template #default="{ row }">
            {{ row.featureCode || row.deviceId }}
          </template>
         </vxe-column>
         <vxe-column field="remarks" title="备注"></vxe-column>
         <vxe-column field="createTime" title="创建时间"></vxe-column>
         <vxe-column title="操作"  width="400">
            <template #default="{ row }">
              <el-button
              v-if="row.featureCode || row.deviceId"
              type="success"
              size="mini"
              @click="senndKey(row)"
              >发送锁匙</el-button
            >
                <el-button
              type="warning"
              size="mini"
              @click="createApartment(row.id)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="deleteUserHandle(row.id)"
              >删除</el-button
            >
            <el-button
            v-if="row.extraId"
              type="info"
              size="mini"
              @click="refreshRoomLock(row.id)"
              >同步上游门锁</el-button
            >
            </template>
         </vxe-column>
        </vxe-table>
    </el-card>
    <base-pagination
      :total="total"
      :currentPage="queryInfo.pageNum"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></base-pagination>
    <add-orga-apartment :addData="addData" @successHandle="successHandle"></add-orga-apartment>
    <edit-orga-apartment :editData="editData" @successHandle="successHandle"></edit-orga-apartment>
    <send-key-dialog :editData="sendKeyData" @successHandle="successHandle2"></send-key-dialog>
  </div>
</template>

<script>
import { getOrgaApartmentPage, delOrgaApartment, getOrgaInfoListAll, getAllOrgaBuildByOrgaId } from '@/api/orga'
import { refreshRoomByApartmentId } from '@/api/yjylock'
import addOrgaApartment from './dialog/addOrgaApartment.vue'
import editOrgaApartment from './dialog/editOrgaApartment.vue'
import sendKeyDialog from './dialog/sendKeyDialog.vue'
import { mapState } from 'vuex'

export default {
  components: {
    addOrgaApartment,
    editOrgaApartment,
    sendKeyDialog
  },
  computed: {
    ...mapState('login', {
      userInfo: (state) => state.userInfo
    })
  },
  data () {
    return {
      loading: false,
      sendKeyData: {
        isOpen: false,
        lockIdList: []
      },
      addData: {
        isOpen: false
      },
      editData: {
        isOpen: false,
        id: ''
      },
      queryInfo: {
        orgaId: '',
        buildId: '',
        floorNum: '',
        pageNum: 1,
        pageSize: 10,
        keyword: '',
        isNoLock: false
      },
      orgaInfoList: [],
      orgaApartmentList: [],
      buildList: [],
      floorList: [],
      total: 0
    }
  },
  created () {
    if (this.userInfo.userType === 1) {
      this.getOrgaInfoListAllFn()
    } else {
      this.queryInfo.orgaId = this.userInfo.orgaId
      this.getbuildList()
    }
    this.getOrgaApartmentPage()
  },
  methods: {
    // 同步房间上游门锁
    refreshRoomLock (id) {
      this.loading = true
      refreshRoomByApartmentId({ id }).then(() => {
        this.loading = false
        this.$message({
          type: 'success',
          message: '同步成功'
        })
        this.getOrgaApartmentPage()
      }).catch(() => {
        this.loading = false
      })
    },
    // 导入房间用户
    importHouse (file) {
      this.loading = true
      const data = new FormData()
      data.append('file', file.raw)
      this.$http.importExcelHttp.importLockKeyUser(data).then((res) => {
        this.loading = false
        if (res.data.success) {
          this.$message({
            type: 'success',
            message: res.data.msg || '导入成功'
          })
          this.getOrgaApartmentPage()
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg || '导入失败，请重新导入'
          })
        }
      })
    },
    // 批量发送锁匙
    batchSenndKey () {
      const records = this.$refs.buildTable.getCheckboxRecords()
      if (records.length === 0) {
          return this.$message({
              type: 'info',
              message: '请选择需要发送锁匙的房间'
            })
      }
      const idList = []
     records.forEach(item => {
        idList.push(item.lockId)
     })
     console.log(idList)
      this.sendKeyData.isOpen = true
      this.sendKeyData.lockIdList = idList
    },
    // 打开发送锁匙
    senndKey (row) {
      this.sendKeyData.isOpen = true
      this.sendKeyData.lockIdList = [row.lockId]
    },
    // 清空组织时
    clearOrga () {
      this.queryInfo.buildId = ''
      this.queryInfo.floorNum = ''
      this.buildList = []
      this.floorList = []
      this.queryInfo.pageNum = 1
      this.getOrgaApartmentPage()
    },
    // 切换楼栋时生成楼层选项
    onBuildChange () {
      this.queryInfo.floorNum = ''
      this.floorList = []
      const build = this.buildList.find(item => item.id === this.queryInfo.buildId)
      if (build && build.floorCount) {
        for (let i = 1; i <= build.floorCount; i++) {
          this.floorList.push({ value: i, label: i + '层' })
        }
      }
      this.getOrgaApartmentPage()
    },
    // 清空楼栋时
    clearBuild () {
      this.queryInfo.floorNum = ''
      this.floorList = []
      this.getOrgaApartmentPage()
    },
    // 获取楼栋房间列表
    getOrgaApartmentPage () {
      this.loading = true
      getOrgaApartmentPage(this.queryInfo).then((res) => {
        this.orgaApartmentList = res.data.list
        this.total = res.data.total
        this.loading = false
      })
    },
    // 获取所有组织
    getOrgaInfoListAllFn () {
      getOrgaInfoListAll().then(res => {
        console.log('获取到的组织', res.data)
        this.orgaInfoList = res.data
      })
    },
    // 根据组织获取楼栋树
    getbuildList () {
      this.queryInfo.buildId = ''
      this.queryInfo.floorNum = ''
      this.floorList = []
      if (!this.queryInfo.orgaId) { return }
      getAllOrgaBuildByOrgaId(this.queryInfo.orgaId).then(res => {
        this.buildList = res.data
      })
      this.getOrgaApartmentPage()
    },
    // 添加与编辑用户
    createApartment (id) {
      if (id.length) {
        this.editData.isOpen = true
        this.editData.id = id
      } else {
        this.addData.isOpen = true
      }
    },
    // 改变分页条目
    handleSizeChange (size) {
      this.queryInfo.pageNum = 1
      this.queryInfo.pageSize = size
      this.getOrgaApartmentPage()
    },
    // 改变页数
    handleCurrentChange (page) {
      this.queryInfo.pageNum = page
      this.getOrgaApartmentPage()
    },
    // 删除房间
    deleteUserHandle (id) {
      this.$confirm('此操作将永久删除该楼栋, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delOrgaApartment(id).then((res) => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getOrgaApartmentPage()
          })
        })
        .catch(() => {
          this.$message({
            type: 'warning',
            message: '已取消删除'
          })
        })
    },
    // 成功发送后
    successHandle2 () {
      this.getOrgaApartmentPage()
    },
    // 监听成功添加与编辑
    successHandle () {
      this.$refs.buildTable.clearCheckboxRow()
      this.getOrgaApartmentPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.header-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
  padding: 4px 0;

  .header-item {
    flex-shrink: 0;

    ::v-deep .el-select {
      width: 150px;
    }
  }

  .header-search {
    flex: 1 1 200px;
    min-width: 180px;
    max-width: 320px;
  }

  .header-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-left: auto;

    .uploadFile {
      display: inline-block;
    }
  }
}
</style>
